
export const banerData = [
    { id: 1, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/beacdf4c7793a4b2.jpg?q=50'},
    { id: 2, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/6bf746555a185832.jpg?q=50'},
    { id: 3, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/25e23476c0deef88.jpg?q=50'},
    { id: 4, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/1dc285cc396b2d23.jpg?q=50'},
    { id: 5, url: 'https://rukminim1.flixcart.com/flap/1688/280/image/e0c3c470bc6c68d7.jpg?q=50'},
    { id: 6, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/fd23a7fdee81c3de.jpg?q=50'},
    { id: 7, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/f2af1d36a53fce46.jpg?q=50'},
    { id: 8, url: 'https://rukminim1.flixcart.com/fk-p-flap/1688/280/image/e807adf684e04ec9.jpeg?q=50'}
]
export const electronics = [
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/29327f40e9c4d26b.png?q=100",
        title: "Grocery"
    },
    
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/22fddf3c7da4c4f4.png?q=100",
        title: "Mobiles"
    },
    {

        image: "https://rukminim1.flixcart.com/flap/128/128/image/c12afc017e6f24cb.png?q=100",
        title: "Fashion"
    },
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/69c6589653afdb9a.png?q=100",
        title: "Electronics"
    },
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/ab7e2b022a4587dd.jpg?q=100",
        title: "Home"
    },
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/0ff199d1bd27eb98.png?q=100",
        title: "Appliances"
    },
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/71050627a56b4693.png?q=100",
        title: "Travel"
    },
    {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/f15c02bfeb02d15d.png?q=100",
        title: "Top Offers"
    },
     {
        image: "https://rukminim1.flixcart.com/flap/128/128/image/dff3f7adcf3a90c6.png?q=100",
        title: "Beauty, Toya & More"
    }
    ,
    {
        image: "https://rukminim1.flixcart.com/fk-p-flap/128/128/image/05d708653beff580.png?q=100",
        title: "Two Wheelers"
    }
]
